import { createFeatureSelector } from '@ngrx/store';
import { EntitiesState } from './entities.state';

/**
 * Feature-Key für den Entities-State.
 */
export const ENTITIES_FEATURE_KEY = 'entities';

/**
 * Feature-Selector für den gruppierten Entities-State.
 * Wird von den einzelnen Entity-Selectors als Basis verwendet.
 */
export const selectEntities = createFeatureSelector<EntitiesState>(ENTITIES_FEATURE_KEY);
